import React from 'react';

export default function NoMarkerSelected() {
  return <form className="marker-settings-no-selected">No marker selected</form>;
}
